import { render } from "./index.vue?vue&type=template&id=475afed4&bindings={}"
import script from "./PuzzleBoard.js?vue&type=script&lang=js"
export * from "./PuzzleBoard.js?vue&type=script&lang=js"

import "./PuzzleBoard.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script